import React from 'react';
import { Typography } from 'seagull';
import styles from "./ScheduledInvoice.module.scss";
import { timeModel } from "../../../../models";
import { utils } from "../../../../utils";
import { LineItemPendingApprovalReason } from "../../../../types/api.model";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
export const columnDefs = [{
  width: [180, 400]
},
// Service Name
{
  width: [80, 90],
  hAlign: 'end'
},
// Quantity
{
  width: [112, 120],
  hAlign: 'end'
},
// Rate
{
  width: [80, 90],
  hAlign: 'end'
},
// Discount
{
  width: [88, 104],
  hAlign: 'end'
},
// Total
{
  width: 168
},
// Status
{
  width: 96
} // Actions
];
export const headerItems = [{
  value: 'Service Name'
}, {
  value: 'Quantity'
}, {
  value: 'Rate'
}, {
  value: 'Discount'
}, {
  value: 'Total'
}, {
  value: 'Status'
}, {
  value: ''
}];
export const HeaderDateIndicator = props => {
  const {
    label,
    date,
    testid
  } = props;
  const {
    BILL_CLIENT
  } = useFeatureFlags();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.headerDateIndicator
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    weight: "normal"
  }, label), /*#__PURE__*/React.createElement(Typography, {
    variant: "paragraph2",
    "data-testid": testid
  }, BILL_CLIENT ? timeModel.formatDateLong(date) : timeModel.formatDate(date)));
};
export const makeTestId = charge => "scheduled-invoice-row-".concat(charge.id);
export function displayLineItemRate(rate) {
  return !rate || rate.amount.isZero() ? '' : rate.unit ? "".concat(utils.formatDollarAmount(rate.amount), "/").concat(rate.unit) : utils.formatDollarAmount(rate.amount);
}
export function getClientStatusTooltip(pendingApprovalReason) {
  switch (pendingApprovalReason) {
    case LineItemPendingApprovalReason.AdHocCharge:
      return 'Your ongoing agreement does not cover this charge';
    case LineItemPendingApprovalReason.ServiceAmendment:
      return 'There is an unapproved amendment to this service';
    case LineItemPendingApprovalReason.VariableExceedsCap:
      return 'The amount charged exceeds the preapproved quantity';
    case LineItemPendingApprovalReason.VariableZeroCap:
      return 'A preapproved quantity was not set for this service';
    case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
      return 'The amount charged exceeds the preapproved rate';
    case LineItemPendingApprovalReason.VariableCumulative:
      return 'The amount charged exceeds the preapproved quantity';
    case LineItemPendingApprovalReason.NonVariableCumulative:
    case LineItemPendingApprovalReason.OverlappingPeriod:
      return 'A charge for this service was issued more than once during this period';
  }
}
export function getVendorStatusTooltip(pendingApprovalReason) {
  switch (pendingApprovalReason) {
    case LineItemPendingApprovalReason.AdHocCharge:
      return 'Out-of-agreement charges require client approval';
    case LineItemPendingApprovalReason.ServiceAmendment:
      return 'Amendment is pending client approval';
    case LineItemPendingApprovalReason.VariableExceedsCap:
      return 'Exceeding the preapproved quantity requires client approval';
    case LineItemPendingApprovalReason.VariableZeroCap:
      return 'A preapproved quantity was not set for this service';
    case LineItemPendingApprovalReason.RangeExceedsMaxPrice:
      return 'Exceeding the preapproved rate requires client approval';
    case LineItemPendingApprovalReason.VariableCumulative:
      return 'Exceeding the preapproved quantity requires client approval';
    case LineItemPendingApprovalReason.NonVariableCumulative:
    case LineItemPendingApprovalReason.OverlappingPeriod:
      return 'Billing this service more than once per period requires client approval';
  }
}